import { Nav, Tab } from "react-bootstrap";
import { ILicenceProfile, isIELIPCorWaste } from "../../api/ILicenceProfile";
import { GetLicenceProfileUrl } from "../../external-apps/Config";

interface TabsWithTextLabelType {
  className?: string;
  activeKey: string;
  content: JSX.Element;
  licenceProfile: ILicenceProfile;
}

const LicenceProfileSubTabs = ({
  className,
  activeKey,
  content,
  licenceProfile,
}: TabsWithTextLabelType) => {
  const licenceProfileUrl = GetLicenceProfileUrl(
    licenceProfile.type,
    licenceProfile.profileNo,
    licenceProfile.activeLicenceVersion.licence_id,
    licenceProfile.activeLicenceVersion.reg_no
  );

  return (
    <div className={"tab " + className}>
      <Tab.Container id="left-tabs-example" defaultActiveKey={activeKey}>
        <Nav variant="tabs">
          <Nav.Item>
            <Nav.Link eventKey="licence-dashboard" href={licenceProfileUrl}>
              Authorisation Dashboard
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              eventKey="licence-versions"
              href={`${licenceProfileUrl}/versions`}
            >
              Authorisation Versions
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              eventKey="compliance-records"
              href={`${licenceProfileUrl}/compliance`}
            >
              Compliance Records
            </Nav.Link>
          </Nav.Item>
          {isIELIPCorWaste(licenceProfile) && (
            <Nav.Item>
              <Nav.Link
                eventKey="environmental-liabilities"
                href={`${licenceProfileUrl}/environmental`}
              >
                Environmental Liabilities
              </Nav.Link>
            </Nav.Item>
          )}
        </Nav>
        <Tab.Content>
          <Tab.Pane eventKey="licence-dashboard">{content}</Tab.Pane>
          <Tab.Pane eventKey="licence-versions">{content}</Tab.Pane>
          <Tab.Pane eventKey="compliance-records">{content}</Tab.Pane>
          {isIELIPCorWaste(licenceProfile) && (
            <Tab.Pane eventKey="environmental-liabilities">{content}</Tab.Pane>
          )}
        </Tab.Content>
      </Tab.Container>
    </div>
  );
};

export default LicenceProfileSubTabs;
